import { Redo2Icon } from 'lucide-react';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';

export const FlowSubmitButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ children, className, ...props }) => {
  return (
    <Button
      className={cn('w-40', className)}
      variant={'greenGradient'}
      btnType={'primary'}
      type="submit"
      {...props}
    >
      {children}
    </Button>
  );
});

export const FlowBackButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, children, onClick, ...props }, ref) => {
  const navigate = useNavigate();

  return (
    <Button
      className={cn('w-40', className)}
      variant={'outline'}
      btnType="primary"
      type="button"
      ref={ref}
      onClick={(event) => {
        if (onClick) {
          onClick(event);
          return;
        } else {
          navigate(-1);
        }
      }}
      {...props}
    >
      {children}
    </Button>
  );
});

export const FlowSkipStepButton = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ children, ...props }, ref) => {
  const { t } = useTranslation('shared');

  return (
    <Button
      variant={'outline'}
      btnType="secondary"
      type="button"
      ref={ref}
      {...props}
    >
      <Redo2Icon />
      {children ?? t('skip')}
    </Button>
  );
});
